module.exports = __webpack_public_path__ + "static/img/Jars.873db5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/drawing_painting/Jars.jpg
// module id = 0N+z
// module chunks = 1